import Chip from '@mui/material/Chip';
import React from 'react';
import { CurrencyCode } from '../../../types/currencyCode';
import { formatCurrency } from '../../../util/util';

interface CashBalanceDisplayPillProps {
	amount: string;
	currencyCode: string;
}

const CashBalanceDisplayPill = (props: CashBalanceDisplayPillProps) => {
	const { amount, currencyCode } = props;

	const parsedAmount = parseFloat(amount);

	if (Number.isNaN(parsedAmount)) {
		return (
			<Chip label='Error Parsing Cash Balance' color='warning' size='small' />
		);
	}

	const formattedAmount = formatCurrency(
		parsedAmount,
		currencyCode as CurrencyCode,
	);

	if (parsedAmount === 0) {
		return <Chip label={formattedAmount} size='small' />;
	} else if (parsedAmount < 0) {
		return <Chip label={formattedAmount} color='error' size='small' />;
	} else {
		return <Chip label={formattedAmount} color='success' size='small' />;
	}

	return <div></div>;
};

export default CashBalanceDisplayPill;
